import {IntermediatePart} from "../../intermediatePart";

export default class Carpet extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'carpet';
    this.partName = 'Carpet';
    this.translateId = "visualizer.bathroom.shower.carpet";
    this.canBeDisabled = true;
  }

}
